/**
 * @author: Matthew Rawson @ 19/09/2017 12:08
 * @todo: implement scoped storage with tenant key prefix
 * @notes: Removed from being a console warning. No idea if this is still relevant.
 */
var get = function (key) {
    var item = localStorage.getItem(key);
    if (!item) {
        item = sessionStorage.getItem(key);
    }
    if (!item) {
        return null;
    }
    return JSON.parse(item);
};
var set = function (key, value) {
    if (value && value.rememberMe) {
        localStorage.setItem(key, JSON.stringify(value));
    }
    else {
        sessionStorage.setItem(key, JSON.stringify(value));
    }
};
var clear = function (key) {
    if (typeof key === "string" && key !== "") {
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
    }
    else {
        localStorage.clear();
        sessionStorage.clear();
    }
};
var storage = { get: get, set: set, clear: clear };
export default storage;
